import { type PayloadAction } from "@reduxjs/toolkit";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../../Application/slices/createFetchingItemsSlice";
import { type Integration } from "../../types";

export type IntegrationOverviewState = FetchingItemsState<Integration>;

const initialState: IntegrationOverviewState = {
  items: [],
  isLoading: false,
  itemsCount: 0,
  error: undefined,
};

const integrationOverviewSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.Integrations,
    name: "overview",
  },
  initialState,
  reducers: {
    triggerSync(state: IntegrationOverviewState, action: PayloadAction<{ id: number; type: string }>) {
      state.items = state.items.map((item) =>
        item.id === action.payload.id && item.type === action.payload.type ? { ...item, isSyncRunning: true } : item,
      );
    },
  },
});

export const { fetchBegin, fetchSuccess, fetchFailure, reset, triggerSync } = integrationOverviewSlice.actions;

export default integrationOverviewSlice.reducer;
export type integrationOverviewSliceType = ReturnType<typeof integrationOverviewSlice.reducer>;
